export default "__VITE_ASSET__DoEwKfN$__"